module.exports = __webpack_public_path__ + "static/scale-model-of-escape-room-rhode-island-in-providence-rhode-island-365a07920b63313b24fd7ce340c35507.png";